/**
 * Created by mac on 9/25/20
 */

const AdminLevels = function (administrator) {
    cleverapps.EventEmitter.call(this);

    this.levels = [];

    this.episodeStatistics = new EpisodeStatistics();
    this.versions = new LevelVersions();

    this.onReadyListeners = [];

    this.ready = false;

    this.episodeStatistics.whenReady(this.onStatisticsLoaded.bind(this));

    administrator.adminEpisodes.onUpdateHoverEpisodeListener = this.onUpdateEpisodesHover.bind(this);
};

AdminLevels.prototype = Object.create(cleverapps.EventEmitter.prototype);
AdminLevels.prototype.constructor = AdminLevels;

AdminLevels.prototype.onUpdateEpisodesHover = function () {
    if (this.draggingLevel) {
        this.draggingLevel.setDragEpisode(cleverapps.administrator.adminEpisodes.hoverEpisode);
    }
};

AdminLevels.prototype.addLevel = function (adminLevel) {
    this.levels.splice(adminLevel.levelNo, 0, adminLevel);

    for (let i = 0; i < this.levels.length; i++) {
        if (!this.levels[i].isAddMoreLevel()) {
            this.levels[i].levelNo = i;
        }
    }

    this.trigger("addLevel", adminLevel);
};

AdminLevels.prototype.makeCurrent = function (adminLevel) {
    cleverapps.user.currentPhysicalLevel.level = parseInt(adminLevel.levelNo);
    cleverapps.user.currentPhysicalLevel.episode = parseInt(adminLevel.episodeNo);
    cleverapps.user.save();

    const location = cleverapps.meta.getSelectedLocation();
    if (typeof HoseLocation !== "undefined" && location instanceof HoseLocation) {
        location.setStage(cleverapps.user.currentPhysicalLevel.episode);
        location.setProgress(cleverapps.user.currentPhysicalLevel.level);
    }

    if (typeof SimpleLocation !== "undefined" && location instanceof SimpleLocation) {
        location.setStage(cleverapps.user.currentPhysicalLevel.episode);
        location.setProgress(cleverapps.user.currentPhysicalLevel.level);
    }
};

AdminLevels.prototype.update = function () {
    this.levels.forEach((level) => {
        level.onUpdate();
    });
};

AdminLevels.prototype.copyLevel = function (adminLevel) {
    const adminEpisode = cleverapps.administrator.adminEpisodes.getActive();
    const episodeNo = adminEpisode.episodeNo;
    const fromLevelNo = adminLevel.levelNo;

    this.processEpisodeContent(episodeNo, (content) => {
        content.levels.push(JSON.parse(JSON.stringify(content.levels[fromLevelNo])));
    });
};

AdminLevels.prototype.moveLevel = function (options) {
    options = options || {};

    const episodeNo = options.episodeNo;
    const fromLevelNo = options.fromLevelNo;
    const toLevelNo = options.toLevelNo;
    const callback = options.callback;

    this.processEpisodeContent(episodeNo, (content) => {
        const contentToMove = content.levels[fromLevelNo];
        content.levels.splice(fromLevelNo, 1);
        content.levels.splice(toLevelNo, 0, contentToMove);
    }, callback);
};

AdminLevels.prototype.updateLevels = function () {
    this.levels.forEach((level) => {
        level.onUpdate();
    });
};

AdminLevels.prototype.dragLevel = function (adminLevel, levelNo) {
    this.levels.splice(adminLevel.levelNo, 1);
    this.levels.splice(levelNo, 0, adminLevel);

    this.levels.forEach((level, levelNo) => {
        level.setLevelNo(levelNo);
    });
};

AdminLevels.prototype.getStatistics = function () {

};

AdminLevels.prototype.createNew = function (blankContent, callback) {
    const adminEpisode = cleverapps.administrator.adminEpisodes.getActive();
    const episodeNo = adminEpisode.episodeNo;
    const levelNo = this.levels.length - 1;

    blankContent.levelNo = levelNo;
    blankContent.episodeNo = episodeNo;

    this.processEpisodeContent(episodeNo, (content) => {
        content.levels.push(blankContent);
    }, callback);
};

AdminLevels.prototype.removeLevel = function (adminLevel, f) {
    const episodeNo = adminLevel.episodeNo;
    const levelNo = adminLevel.levelNo;

    this.processEpisodeContent(episodeNo, (content) => {
        content.levels.splice(levelNo, 1);
    }, f);
};

AdminLevels.prototype.processEpisodeContent = function (episodeNo, processor, f) {
    f = cleverapps.once(f);

    const language = cleverapps.config.type === "board" ? cleverapps.settings.language : undefined;

    const adminEpisode = cleverapps.administrator.adminEpisodes.getEpisode(episodeNo);
    const bundleName = AdminEpisode.BundleId(episodeNo, language);

    cleverapps.bundleLoader.loadBundle(bundleName, {
        onSuccess: function () {
            let content = JSON.parse(JSON.stringify(cc.loader.getRes(bundles[bundleName].jsons.levels)));
            if (!content.levels) {
                content = { levels: content };
            }

            processor(content);

            content.levels.forEach((level, index) => {
                cleverapps.toArray(level).forEach((levelContent) => {
                    levelContent.levelNo = index;
                    levelContent.episodeNo = episodeNo;
                });
            });

            cleverapps.administrator.adminEpisodes.saveToStorage(episodeNo, content);

            if (cleverapps.administrator.adminEpisodes.getActive() === adminEpisode) {
                this.reset(f);
            } else {
                f();
            }

            cleverapps.bundleLoader.deleteBundle(bundleName);
        }.bind(this),

        onError: function () {
            cleverapps.notification.create(`Can't load bundle ${bundleName}`);
            f();
        }
    });
};

AdminLevels.FIRST_LEVEL = 0;
AdminLevels.LAST_LEVEL = 1;

AdminLevels.prototype.onStatisticsLoaded = function (data) {
    this.whenReady(() => {
        data.forEach(function (levelData) {
            if (this.levels[levelData.levelNo]) {
                this.levels[levelData.levelNo].setDifficulty(levelData.difficulty);
            }
        }, this);
    });

    this.trigger("statisticsLoaded", data);
};

AdminLevels.prototype.reset = function (callback, suggestedLevel) {
    const adminEpisode = this.adminEpisode = cleverapps.administrator.adminEpisodes.getActive();

    if (typeof adminEpisode.episodeNo === "undefined") {
        return;
    }

    this.setActive(undefined);

    this.ready = false;
    this.episodeStatistics.reset();

    this.loadData((adminEpisode) => {
        this.updateData(adminEpisode);
        this.episodeStatistics.reset(adminEpisode);

        let selectedLevel = this.levels[0];
        if (suggestedLevel) {
            if (suggestedLevel === AdminLevels.LAST_LEVEL) {
                selectedLevel = this.levels[this.levels.length - 2];
            } else {
                selectedLevel = this.levels[suggestedLevel];
            }
        }

        if (selectedLevel && !selectedLevel.addMoreLevel) {
            this.setActive(selectedLevel);
        }

        if (callback) {
            callback();
        }

        this.runOnReadyListeners();

        this.ready = true;

        this.trigger("statisticsReset");
    });
};

AdminLevels.prototype.runOnReadyListeners = function () {
    const listeners = this.onReadyListeners;
    this.onReadyListeners = [];
    listeners.forEach(function (listener) {
        listener(this.data);
    }, this);
};

AdminLevels.prototype.whenReady = function (callback) {
    if (this.ready) {
        callback();
    } else {
        this.onReadyListeners.push(callback);
    }
};

AdminLevels.prototype.next = function (sign) {
    const pos = this.levels.indexOf(this.active) + sign;

    if (this.levels[pos] === undefined || this.levels[pos].isAddMoreLevel()) {
        return undefined;
    }

    return this.levels[pos];
};

AdminLevels.prototype.createLevel = function (adminEpisode, levelNo) {
    return AdminLevel.createFromData({
        levelNo,
        episodeNo: adminEpisode.episodeNo,
        version: true
    }, adminEpisode.getEpisodeLevels()[levelNo]);
};

AdminLevels.prototype.updateData = function (adminEpisode) {
    const levelsAndVersions = adminEpisode.getEpisodeLevels();
    this.levels = [];
    for (let levelNo = 0; levelNo < 100 && levelsAndVersions[levelNo]; levelNo++) {
        this.levels.push(this.createLevel(adminEpisode, levelNo));
    }

    this.levels.push(AdminLevel.getAddMoreLevel());

    this.versions.reset();
    this.trigger("reset");
};

AdminLevels.prototype.getActive = function () {
    return this.active;
};

AdminLevels.prototype.getActiveVersions = function () {
    const versions = {};
    this.levels.forEach((adminLevel) => {
        if (!adminLevel.isAddMoreLevel()) {
            versions[adminLevel.levelNo] = adminLevel.getActiveVersion();
        }
    });
    return versions;
};

AdminLevels.prototype.setActive = function (level) {
    if (this.active !== level) {
        if (this.active !== undefined) {
            this.active.unselect();
        }

        this.active = level;

        if (cleverapps.config.adminMode) {
            cleverapps.setUrlHash({
                episode: this.active ? this.active.episodeNo : undefined,
                level: this.active ? this.active.levelNo : undefined
            });
        }

        if (level !== undefined) {
            level.select();
            this.trigger("chartUpdate", level);
            this.trigger("changeActive");
        }

        cleverapps.administrator.adminDetails.reset();
    }
};

AdminLevels.prototype.loadData = function (callback) {
    const adminEpisode = cleverapps.administrator.adminEpisodes.getActive();
    if (!adminEpisode) {
        return;
    }

    adminEpisode.loadData(() => {
        if (adminEpisode !== cleverapps.administrator.adminEpisodes.getActive()) {
            return;
        }

        callback(adminEpisode);
    });
};

AdminLevels.prototype.download = function (callback) {
    this.loadData((adminEpisode) => {
        const data = JSON.stringify(adminEpisode.getEpisodeLevelsContent(), undefined, 4);
        const fileName = `${AdminEpisode.BundleId(cleverapps.administrator.adminEpisodes.getActive().episodeNo)}.json`;

        this.trigger("downloadLevels", {
            fileName,
            data
        });
    });

    callback();
};

AdminLevels.prototype.upload = function (event, callback) {
    const files = event.target.files;
    const file = files[0];
    const end = file.name.indexOf(".json");
    if (end < 0) {
        cleverapps.notification.create("Error - File must be json format");
        callback();
        return;
    }

    const reader = new FileReader();

    reader.onload = function (event) {
        const content = event.target.result;

        cleverapps.administrator.adminEpisodes.upload(content, callback);
    };

    reader.readAsText(file);
};
